import { enumHelper } from "../../utils"
import ENUMS from '../../enums';
import React from 'react';
import { NavLink } from "react-router-dom";
import ReserveCafeModal from "../../screens/discountCodes/discountCodesUsers/ReserveCafeModal";

export const discountCodeUsersCol = [
  {
    title: 'ردیف',
    dataIndex: 'num',
    isRowNumber: true,
  },
  {
    title: 'نام و نام‌ خانوادگی',
    dataIndex: 'userFullName',
    name: 'userFullName',
    isSortable: true,
    render: (text, record) => <NavLink
      to={{
        pathname: '/users/details',
        state: { id: record?.userId },
      }}
    >
      {text}
    </NavLink>

  },
  {
    title: 'شماره همراه کاربر',
    dataIndex: 'userMobileNumber',
    name: 'userMobileNumber',
    isSortable: true,
  },
  {
    title: 'نام کافه',
    dataIndex: 'reserveCafeName',
    name: 'reserveCafeName',
    isSortable: true,
    render: (text, record) => <ReserveCafeModal record={record} />
  },
  {
    title: 'وضعیت',
    dataIndex: 'discountCodeStatus',
    name: 'discountCodeStatus',
    isSortable: false,
    render: text =>
      text && (
        <span
          className='badge badge-secondary'

        >
          {enumHelper.convertEnumValueToTitle(
            ENUMS.DISCOUNT_CODE_USERS_STATUS.list,
            text,
          )}
        </span>
      ),

  },
  {
    title: 'تاریخ استفاده',
    dataIndex: 'usedAt',
    name: 'usedAt',
    isSortable: true,
  },

];